let config = {};

config.thinkificBaseUrl = 'https://api.thinkific.com/api/public/v1/';

config.baseUrl = 'https://www.achievece.net/api/';

export default config;



// WEBPACK FOOTER //
// ./src/config.js